(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["glow-reveal"]) return;
  try {
    
  (function() {
    const box = document.querySelector('[data-scratch]');
    if (!box) return;
    const canvas = box.querySelector('[data-scratch-canvas]');
    const revealBtn = box.querySelector('[data-scratch-reveal]');
    const cta = document.querySelector('[data-glow-cta]');
    if (!canvas) return;

    const ctx = canvas.getContext('2d');
    let revealed = false;
    let drawing = false;

    function resize() {
      const r = box.getBoundingClientRect();
      const dpr = window.devicePixelRatio || 1;
      canvas.width = r.width * dpr;
      canvas.height = r.height * dpr;
      ctx.scale(dpr, dpr);
      // Pink scratch layer with shimmer pattern
      ctx.fillStyle = '#E91E90';
      ctx.fillRect(0, 0, r.width, r.height);
      // Add subtle "scratch me" text
      ctx.font = '600 11px -apple-system, BlinkMacSystemFont, sans-serif';
      ctx.fillStyle = 'rgba(255,255,255,0.7)';
      ctx.textAlign = 'center';
      ctx.fillText('SCRATCH HERE ✦', r.width / 2, r.height / 2 - 8);
      ctx.font = '400 10px -apple-system, BlinkMacSystemFont, sans-serif';
      ctx.fillStyle = 'rgba(255,255,255,0.5)';
      ctx.fillText('zum Freilegen', r.width / 2, r.height / 2 + 8);
      // Set blend mode for erase
      ctx.globalCompositeOperation = 'destination-out';
    }

    resize();
    window.addEventListener('resize', resize);

    function getPos(e) {
      const r = canvas.getBoundingClientRect();
      const x = (e.touches ? e.touches[0].clientX : e.clientX) - r.left;
      const y = (e.touches ? e.touches[0].clientY : e.clientY) - r.top;
      return { x, y };
    }

    function scratch(e) {
      if (!drawing) return;
      e.preventDefault();
      const { x, y } = getPos(e);
      ctx.beginPath();
      ctx.arc(x, y, 22, 0, Math.PI * 2);
      ctx.fill();
      checkProgress();
    }

    function checkProgress() {
      if (revealed) return;
      // Sample every ~10px
      const w = canvas.width, h = canvas.height;
      const sample = ctx.getImageData(0, 0, w, h).data;
      let cleared = 0, total = 0;
      for (let i = 3; i < sample.length; i += 40) {
        total++;
        if (sample[i] < 128) cleared++;
      }
      if (cleared / total > 0.42) finalize();
    }

    function finalize() {
      revealed = true;
      box.classList.add('is-revealed');
      if (cta) {
        cta.hidden = false;
        cta.style.opacity = '0';
        cta.style.transform = 'translateY(8px)';
        cta.style.transition = 'opacity 480ms ease, transform 480ms ease';
        setTimeout(() => {
          cta.style.opacity = '1';
          cta.style.transform = 'translateY(0)';
        }, 60);
      }
    }

    canvas.addEventListener('mousedown', (e) => { drawing = true; scratch(e); });
    canvas.addEventListener('mousemove', scratch);
    canvas.addEventListener('mouseup', () => { drawing = false; });
    canvas.addEventListener('mouseleave', () => { drawing = false; });
    canvas.addEventListener('touchstart', (e) => { drawing = true; scratch(e); }, { passive: false });
    canvas.addEventListener('touchmove', scratch, { passive: false });
    canvas.addEventListener('touchend', () => { drawing = false; });

    revealBtn.addEventListener('click', finalize);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-banner"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var link = document.querySelector('[data-glow-scroll]');
    if (!link) return;
    link.addEventListener('click', function(e) {
      var target = document.getElementById('shopify-section-glow_cta') || document.querySelector('.glow-cta');
      if (target) {
        e.preventDefault();
        var top = target.getBoundingClientRect().top + window.scrollY - 16;
        window.scrollTo({ top: top, behavior: 'smooth' });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
